export function formatToTwoDecimals(value: string | number | null | undefined): string {
  if (value === null || value === undefined || value === '') {
    return '';
  }

  const normalizedValue = typeof value === 'string' ? value.replace(/,/g, '') : value;
  const parsedValue = Number(normalizedValue);

  if (!Number.isFinite(parsedValue)) {
    return String(value);
  }

  return new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(parsedValue);
}
